import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {useHistory} from 'react-router-dom';
import ButtonDropdownActionsView from './ButtonDropdownActions-view';
import {pathnames as P} from 'common/constants/pathnames';
import {getFile} from "../../actions/files/getFile";
import {getFullDataURI} from "../../utils/files/getFullDataURI";
import {downloadFile} from "../../utils/files/downloadFile";
import {showGlobalErrorMessage} from "../../actions/globalErrorMessage/showGlobalErrorMessage";

const ButtonDropdownActions = ({
                                 id,
                                 firmShumaID,
                                 currentUserID,
                                 userID,
                                 adminPermissionsLevel,
                                 shumaTypeID,
                                 originTypeID,
                                 shumaStatusTypeID,
                                 fileID,
                                 fileName,
                                 bankEmail
                               }) => {
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const shumaId = id;
  const editAllowed = (currentUserID === userID && originTypeID === 1) || adminPermissionsLevel === 2;

  const handleEdit = () => {
    history.push(P.GET_INSPECTION_BY_ID(id))
  };

  const handleEditOtherInspection = () => {
    history.push(P.GET_INSPECTION_OTHER_BY_ID(id))
  };

  const handleDownloadPDF = () => {
    Promise.resolve()
      .then(() => setLoading(true))
      .then(() => {
        return getFile({shumaId, fileID})()
      })
      .then(content => {
        const dataURI = getFullDataURI({body: content, file_extension: 'pdf'});
        downloadFile(dataURI, fileName);
      })
      .catch(error => showGlobalErrorMessage(error.message))
      .finally(() => setLoading(false))
  }

  return (
    <ButtonDropdownActionsView
      shumaId={shumaId}
      firmShumaID={firmShumaID}
      editAllowed={editAllowed}
      onEdit={handleEdit}
      onEditOther={handleEditOtherInspection}
      shumaTypeID={shumaTypeID}
      originTypeID={originTypeID}
      shumaStatusTypeID={shumaStatusTypeID}
      fileID={fileID}
      bankEmail={bankEmail}
      loading={loading}
      handleDownloadPDF={handleDownloadPDF}
    />
  )
};

ButtonDropdownActions.propTypes = {
  id: PropTypes.number,
  currentUserID: PropTypes.number,
  userID: PropTypes.number,
  shumaTypeID: PropTypes.number,
  originTypeID: PropTypes.number,
  shumaStatusTypeID: PropTypes.number,
  fileID: PropTypes.number
};

export default ButtonDropdownActions;
